import Stack from "@mui/material/Stack";
import React, { useEffect } from "react";
import MapBox from "../components/dashboard/infoboxes/MapBox";
import InfoBox from "../components/dashboard/infoboxes/InfoBox";
import { TodayInfoBox } from "../components/dashboard/infoboxes/TodayInfoBox";
// import Paper from "@mui/material/Paper";

const Home = () => {
  useEffect(() => {
    window.scrollTo({ top: "0", behavior: "smooth" });
  }, []);

  return (
    <Stack direction="column"  spacing={4}>
      <MapBox />
      <InfoBox title="ORDERS" total="50" lastMonth="0" lastWeek="0" today="0" />
      <TodayInfoBox />
      <InfoBox title="USERS" total="52" lastMonth="0" lastWeek="0" today="0" />
    </Stack>
  );
};

export default Home;
